import React from 'react';
import { ModuleBase, Media, Stack, Text, HeadingTag, RichText } from '@/components';
// import { splitWords } from '@/animations';
import { HeroFullBleedModulePropertiesModel } from '@/client';
import { useTranslations } from 'next-intl';
import Play from '@/assets/play.svg';

const HeroFullBleedModule = ({
  data,
  moduleName,
}: {
  data: HeroFullBleedModulePropertiesModel;
  moduleName: string;
}) => {
  const t = useTranslations();

  return (
    <ModuleBase data={data} moduleName={moduleName} className="relative h-screen overflow-hidden">
      {data.backgroundMedia && (
        <div className="absolute left-0 right-0 top-0 h-full w-full" data-cy="herofull-background-media">
          <Media
            media={{ coverImage: data.backgroundMedia }}
            coverImageProps={{
              widths: { xs: 425, sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 2560 },
              heights: { xs: 700, lg: null },
              dataNotLazy: true,
              preload: true,
            }}
            className="overlay"
          />
        </div>
      )}

      <Stack className="container relative z-30 flex h-full flex-col items-center justify-center text-center md:w-4/5 lg:w-3/5">
        <div className="title-wrapper" role="contentinfo" aria-label="contentinfo">
          {data.preHeading && (
            <Text
              className="text-subheading font-inter my-4 text-base font-semibold uppercase text-white"
              data-cy="herofull-pretitle"
            >
              {data.preHeading}
            </Text>
          )}
          {data.headingTitle && (
            <HeadingTag
              // animation={splitWords}
              data={{
                heading: data.headingTitle,
              }}
              className="color-from-bg font-inter leading-heading1m tracking-heading1m lg:leading-heading1 lg:tracking-heading1 mt-7 justify-center text-5xl font-semibold not-italic !text-white lg:text-7xl"
              data-cy="herofull-title"
            />
          )}
        </div>

        {data.description && (
          <div className="color-from-bg text-heading6 tracking-heading6 mb-4 mt-5 font-light not-italic leading-8">
            <RichText animate data={data.description} className="text-white" />
          </div>
        )}
        <div className="flex">
          {t('general.$close')} <Play className="w-6 fill-white" />
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default HeroFullBleedModule;
